<div class="container">
    <img class="iconStyle" src="{{icon}}" alt="" />
    <div class="titleStyle">{{title}}</div>
    <div class="subtitleStyle">{{subtitle}}</div>
</div>